"use strict";

//	Kilopix

import * as kpm from "../../@kilopix/methods.module";
import * as kpu from "../../@kilopix/utils.module";

//	Modules

import { AppInterface } from "../app.interface";

//	Dom selectors

const appBody = document.getElementById( "body" );
const languages = document.getElementById( "languages" );

//	Footer

export class Footer {
	//	Run

	static run() {
		if ( languages ) {
			languages.addEventListener( "click", function() {
				if ( AppInterface.appMediaQuery < 48 ) {
					if ( !kpm.hasClass(appBody, "show-languages") ) {
						kpm.addClass( this.querySelector( ".label" ), "active" );
						kpm.addClass( appBody, "show-languages" );
					} else {
						kpm.removeClass( languages.querySelector( ".label" ), "active" );
						kpm.removeClass( appBody, "show-languages" );
					}
				}
			});	
		}	
	}
	
	//	Resize

	static resize() {
		if ( languages ) {
			kpm.removeClass( languages.querySelector( ".label" ), "active" );
			kpm.removeClass( appBody, "show-languages" );
		}
	}
}